export class FetchError extends Error {
  constructor(
    public readonly status: number,
    url: string,
  ) {
    super(`${status} from ${url}`);
    this.name = "FetchError";
  }
}

export const fetcher = async (url: string) => {
  const response = await fetch(url);
  if (!response.ok) throw new FetchError(response.status, url);
  return response.json();
};
